
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ServiceHero from './components/ServiceHero';
import ServiceOfferings from './components/ServiceOfferings';

export default function ServicePage() {
  return (
    <div>
      <Header />
      <main>
        <ServiceHero />
        <ServiceOfferings />
      </main>
      <Footer />
    </div>
  );
}
